import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { TableData, TableHead } from "components/Common/UI/Table/Styled";

const TableHeader = ({
  children,
  width,
  accessor,
  sortedColumn,
  sortDirection,
  onClick
}) => (
  <TableHead width={width}>
    <TableData
      onClick={() => onClick(accessor)}
      className={classnames({
        headerCell: true,
        isSorted: accessor === sortedColumn,
        isSortedDesc: sortDirection === "desc",
        canSort: true
      })}
    >
      {children}
    </TableData>
  </TableHead>
);

TableHeader.propTypes = {
  children: PropTypes.node,
  width: PropTypes.number,
  accessor: PropTypes.string,
  sortedColumn: PropTypes.string,
  sortDirection: PropTypes.string,
  onClick: PropTypes.func
};

export default TableHeader;
